// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CXzP","title":"styles_title__1U9YR"};